import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import { redirectIfNoPermission } from 'cio/utils/route-access';
import AlertsService from 'cio/services/alerts';
import RouterService from '@ember/routing/router-service';
import MasqService from 'cio/services/masq';
import AuthService from 'cio/services/auth';
import Transition from '@ember/routing/-private/transition';

export default class IntegrationsRoute extends Route {
  @service alerts!: AlertsService;
  @service auth!: AuthService;
  @service router!: RouterService;
  @service masq!: MasqService;

  crumb() {
    return {
      name: 'Integrations',
      path: this.routeName,
    };
  }

  async beforeModel(transition: Transition) {
    await super.beforeModel(transition);

    return redirectIfNoPermission(this, 'journeys/imports/view', transition);
  }
}
